<template>
	<div>
		<loader v-if="error == ''" />
		<warning-box 
      v-else  
      title="Error"
      :body="error">  
    </warning-box>
	</div>
</template>
<script>
	import {mapGetters,mapMutations,mapActions} from 'vuex';
	import {get} from '@/services/index.js';
	import moment from 'moment'
	import currency from "@/data/currency"
	import WarningBox from '@/components/general/WarningBox'

	export default{
		components:{
			WarningBox
		},
		metaInfo(){
      return {title:'Loading...'}
    },
		data(){
			return{
				currency:currency,
				error: ''
			}
		},
		computed:{
			query(){
				return this.$route.query
			}
		},
		mounted(){
			this.loadMerchant()
		},
		methods:{
			...mapGetters(['getCurrency','getMerchant']),
			...mapMutations(['setCurrency','setBeFilter','resetBECart','setBeSortBy','setBeFilterDetail','setBaseRate','setLanguageMutation','setBeFirstLoad','setBeCustomReload']),
			...mapActions(['setMerchant']),
			loadMerchant(){
				get("CORE_HOTEL","merchant/"+this.query.merchant_id).then(response=>{
        	let res = response.data
      		if(res.success){
      			this.setMerchant({
              type: 'fill',
              data: res.data
            })
      			this.setBeFirstLoad(false)
      			let date_default = moment(`${this.query.checkin_day}-${this.query.checkin_month}-${this.query.checkin_year}`, 'DD-MM-YYYY')
      			let params = {
							date: {
								check_in: moment(date_default).format('YYYY-MM-DD'),
								check_out: moment(date_default).add(this.query.total_night,'d').format('YYYY-MM-DD'),
							},
							guest: {
								adult: this.query.total_adult,
								child: this.query.total_child,
								infant: 0,
							},
							promo_code: ''
						}
						let selected_currency = this.currency.find(x=>x.code == this.getMerchant().base_currency_code)
	  				this.setCurrency(selected_currency)
	  				this.setBaseRate({a:1,b:1})


	  				if(this.query.currency_code == this.getMerchant().base_currency_code){
	  					this.setBaseRate({a:1,b:1})
							this.doneAction(params,res)
	  				}else{
							let record_currency = this.currency.findIndex(x=>x.code == this.query.currency_code)
							if(record_currency != -1){
								this.$convertCurrency(this.query.currency_code)
								.then(()=>{
									this.setCurrency(this.currency[record_currency])
									this.doneAction(params,res)
								}).catch(err=>{
									console.log("INTERNAL ERROR CRNCY :", err)
								})
							}else{
								let default_currency = this.currency.findIndex(x => x.code == 'USD')
								this.$convertCurrency('USD')
								.then(res_lang=>{
									this.setCurrency(this.currency[default_currency])
									this.doneAction(params,res)
								}).catch(err=>{
									console.log("INTERNAL ERROR CRNCY :", err)
								})
							}
	  				}
      		}else{
      			this.error = 'Property not found'
      		}
      	})
			},
			doneAction(params,res){
				let language_code = this.query.language_code.toLowerCase() == 'id' ? 'id' : 'en'
				this.setLanguageMutation(language_code)
				this.setBeFilter(params)
				this.resetBECart()
				this.setBeSortBy('room_type')
				this.setBeFilterDetail({
					type: 'room_type',
					data: {}
				})
				let base_url = window.location.origin
				window.location.assign(`${base_url}/${res.data.code}/booking`)
			}
		}
	}
</script>


// WEBPACK FOOTER //
// src/pages/hotel/be/BeDirectBookingGoogle.vue